module.exports = __webpack_public_path__ + "img/06.36b8fc04.jpg";